"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobilePush = exports.OperatingSystem = exports.MobileType = void 0;
/** https://github.com/react-native-device-info/react-native-device-info#getdevicetype */
var MobileType;
(function (MobileType) {
    MobileType["Handset"] = "Handset";
    MobileType["Tablet"] = "Tablet";
    MobileType["Tv"] = "Tv";
    MobileType["Desktop"] = "Desktop";
    MobileType["GamingConsole"] = "GamingConsole";
    MobileType["Headset"] = "Headset";
    MobileType["unknown"] = "unknown";
})(MobileType || (exports.MobileType = MobileType = {}));
/** https://github.com/react-native-device-info/react-native-device-info#getsystemname */
var OperatingSystem;
(function (OperatingSystem) {
    OperatingSystem["Android"] = "Android";
    OperatingSystem["iOS"] = "iOS";
})(OperatingSystem || (exports.OperatingSystem = OperatingSystem = {}));
/** an enumeration of supported mobile push services */
var MobilePush;
(function (MobilePush) {
    /** Google Firebase Cloud Messaging (FCM) */
    MobilePush["FCM"] = "GCM";
    /** Apple Push Notification Service (APNS) */
    MobilePush["APNS"] = "APNS";
    /** Apple Push Notification Service - Development (APNS_SANDBOX) */
    MobilePush["APNS_SANDBOX"] = "APNS_SANDBOX";
})(MobilePush || (exports.MobilePush = MobilePush = {}));
